import { SxProps, Theme } from "@mui/material/styles";

export const captainCardContainer =
    (height: string): SxProps<Theme> =>
    (theme) => ({
        height: height,
        position: "relative",
        overflow: "hidden",
        fontFamily: "HsvSlab",
        backgroundColor: theme.palette.primary.main,
    });

export const captainCardImage: SxProps<Theme> = {
    backgroundSize: "cover",
    backgroundPosition: "center",
    width: "100%",
    height: "100%",
    position: "absolute",
    top: 0,
    left: 0,
};
